import React from 'react';

import { BitbucketIcon } from '@atlaskit/logo/bitbucket-icon';

import { Products } from '../../constants';
import type { FallbackUrl, GlobalShortcutConfiguration, GlobalShortcutLinkItem } from '../../types';
import { useAppGlobalShortcutLinkItem } from '../../utils/use-app-global-shortcut-link-item';
import { messages } from './messages';

const icon = <BitbucketIcon size="xsmall" label="" />;

export const useBitbucket = (
	fallbackUrl: FallbackUrl,
	options: GlobalShortcutConfiguration = {},
): GlobalShortcutLinkItem =>
	useAppGlobalShortcutLinkItem(icon, messages.label, fallbackUrl, {
		apsKey: Products.BITBUCKET,
		analyticsName: Products.BITBUCKET,
		...options,
	});
